import { render } from "./AdminNavbar.vue?vue&type=template&id=34f9d3f6&scoped=true"
import script from "./AdminNavbar.vue?vue&type=script&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&lang=js"

import "./AdminNavbar.vue?vue&type=style&index=0&id=34f9d3f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f9d3f6"]])

export default __exports__